import { IAmbassadorQuote } from '@models/IAmbassadorQuote';
import { IMeta } from '@models/IMeta';
import AmbassadorQuoteCard from '@molecules/AmbassadorQuotesCard/AmbassadorQuotesCard';
import PaginationCarousel from '@molecules/PaginationCarousel/PaginationCarousel';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import { SwiperSlide } from 'swiper/react';

interface Props {
  readonly title?: string;
  readonly quotes?: IAmbassadorQuote[];
  readonly anchorId?: string;
  readonly meta?: IMeta;
}

const AmbassadorQuotes = ({
  title,
  quotes = [],
  anchorId = '',
  meta,
}: Props) => {
  const quotesFiltered = quotes.filter((quote) => quote.image?.image);
  const lightBoxIds = quotes.map(({ image }) => `${image.meta?.contentLink}`);

  return (
    <section
      id={`a-${anchorId}`}
      className="component-padding dark bg-black-100 text-white"
      data-testid="CT-46-Ambassador-Quotes"
    >
      <SoftLoadWrapper>
        {!!quotesFiltered?.length && (
          <div className="container">
            {title && (
              <h2
                className="p pb-8 lg:pb-13"
                data-epi-property-name={meta?.editHints?.title}
                data-testid="CT-46-Ambassador-Quotes-Title"
              >
                {title}
              </h2>
            )}

            <PaginationCarousel
              id={`ambassador-quotes-${meta?.contentLink ?? ''}`}
              paginationClasses="mt-7.5 lg:-mt-[45px]"
              data-testid="CT-46-Ambassador-Quotes-Carousel"
            >
              {quotesFiltered.map((quote, index) => (
                <SwiperSlide
                  key={`${quote.quoteAuthor}-${quote.quote?.substring(0, 10)}`}
                >
                  <AmbassadorQuoteCard
                    {...quote}
                    contentIds={lightBoxIds}
                    dataTestId={`CT-46-Ambassador-Quotes-Carousel-Slide-${index}`}
                  />
                </SwiperSlide>
              ))}
            </PaginationCarousel>
          </div>
        )}
      </SoftLoadWrapper>
    </section>
  );
};

export default AmbassadorQuotes;
